/**
 * Leave Reason Select Component
 * Dropdown for eSocial leave reasons
 *
 * @version 2025.1.0
 */
import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from '@mui/material';
import { LEAVE_REASONS } from '../../../types/medicalLeave';

interface LeaveReasonSelectProps {
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  required?: boolean;
}

export const LeaveReasonSelect: React.FC<LeaveReasonSelectProps> = ({
  value,
  onChange,
  error = false,
  helperText,
  disabled = false,
  required = false,
}) => {
  return (
    <FormControl fullWidth required={required} error={error}>
      <InputLabel>Motivo do Afastamento</InputLabel>
      <Select
        value={value}
        label="Motivo do Afastamento"
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      >
        {LEAVE_REASONS.map((reason) => (
          <MenuItem key={reason} value={reason}>
            {reason}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default LeaveReasonSelect;
